import type { IdeaLabEntryCoverageSummary } from '@einhaus/project314-types';

export const coverageReasonLabel = (reason: IdeaLabEntryCoverageSummary['byReason'][number]['reason']): string =>
    reason === 'invalid_price' ? 'Price-quality hold' : 'Required history unavailable';

/** Shared by the report and its copied completion summary; counts retain their actual units. */
export const describeEntryCoverage = (coverage: IdeaLabEntryCoverageSummary): string => {
    const { population } = coverage;
    const parts = [
        `${population.evaluatedEntityCount} of ${population.requestedEntityCount} requested entities evaluated`,
        `${population.excludedEntityCount} whole entities excluded`
    ];
    if (population.failedEntityCount > 0) parts.push(`${population.failedEntityCount} entities failed`);
    parts.push(`${coverage.skippedSessionCount.toLocaleString('en-US')} symbol-sessions excluded within evaluated entities`);
    if (coverage.skippedSessionCount > 0) {
        parts.push(`${coverage.firstSessionDate} to ${coverage.lastSessionDate}`);
        parts.push(
            coverage.byReason
                .map((row) => `${coverageReasonLabel(row.reason)}: ${row.skippedSessionCount.toLocaleString('en-US')}`)
                .join('; ')
        );
    }
    return `${parts.join(' · ')}.`;
};
